import React from "react";
import classNames from "classnames";
import { useUiContext } from "@rotorstudios/fe-ui";

import LayoutGrid from "../../../uiLayouts/LayoutGrid/LayoutGrid";
import VehicleCard, { IVehicleCard } from "./VehicleCard";
import { QA_ALL_VEHICLES_GRID_ITEM } from "../../../modules/Data/static";
import "./VehicleCardsGrid.scss";

interface VehicleCardsGridProps {
  vehicleCards?: IVehicleCard[];
  customClassName?: string;
  columns?: number;
  gap?: number;
  onButtonClick?: (id: string) => void;
}

const VehicleCardsGrid: React.FC<VehicleCardsGridProps> = ({
  customClassName = "",
  vehicleCards = [],
  columns = 3,
  gap = 1,
  onButtonClick = () => {},
}) => {
  const { projectClass, breakpointActive } = useUiContext();

  const getClassName = () =>
    classNames(`${projectClass}_VehicleCardsGrid`, breakpointActive, customClassName, {
      [`vehicleCards`]: (vehicleCards?.length ?? 0) > 0,
    });

  return (
    <LayoutGrid customClass={getClassName()} columns={columns} gap={gap}>
      {vehicleCards.map((vehicle) => (
        <div
          key={vehicle.id}
          className={`${projectClass}_VehicleCardsGrid__item`}
          data-qa={QA_ALL_VEHICLES_GRID_ITEM}
        >
          <VehicleCard card={vehicle} onButtonClick={() => onButtonClick?.(vehicle.id)} />
        </div>
      ))}
    </LayoutGrid>
  );
};

export default VehicleCardsGrid;
